import { connect } from 'react-redux'
import { submit, isSubmitting } from 'redux-form'

import { actions as LKModalActions } from 'shared/LKModal'
import { FORM_NAME, MODAL_NAME } from './constants'

const mapStateToProps = (state) => ({
  submitting: isSubmitting(FORM_NAME)(state),
})

const mapDispatchToProps = (dispatch) => ({
  submit: () => {
    dispatch(submit(FORM_NAME))
  },

  closeModal: () => {
    dispatch(LKModalActions.close(MODAL_NAME))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)
